import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'border-b border-background-200/70 bg-background-50/90 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8 lg:px-12">
        <a href="#top" className="flex cursor-pointer items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-950">黑料官网</span>
            <span className="mt-1 text-[11px] tracking-[0.2em] text-foreground-500">访问指引站</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="cursor-pointer whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors duration-200 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#channels"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            <i className="ri-links-line text-base"></i>
            获取最新地址
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#channels"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            <i className="ri-links-line text-base"></i>
            获取最新地址
          </a>
        </div>
      )}
    </header>
  );
}